import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';

export interface TagCategory {
  id: string;
  name: string;
  defaultColor: string;
  isEditable: boolean;
}

export function useTagCategories() {
  return useQuery<TagCategory[]>({
    queryKey: ['tagCategories'],
    queryFn: () => api.get<TagCategory[]>('/tagCategory'),
    staleTime: 10 * 60 * 1000,
  });
}
